import ru_RU from '@uppy/locales/lib/ru_RU.js';
import datepickerRU from 'air-datepicker/locale/ru';

const { dateFormat, timeFormat, ...datepicker } = datepickerRU;
/** Параметры ввода и сохранения данных для языка ru. */
const ruInputFormats = {
    dateFormat,
    timeFormat,
    archivalDateDecadeSuffix: 'е'
};
const ru = {
    lang: "ru",
    askDeleteCollectionItems: 'Удалить выбранные элементы?',
    alertDeleteItems: 'Выбранные элементы будут удалены окончательно <br/>без возможности восстановления. <br/>Вы уверены?',
    apply: "Применить",
    close: 'Закрыть',
    cancel: 'Отменить',
    confirm: 'Подтвердить',
    closeUnsavedTabConfirmation: 'Форма содержит не сохраненные данные.\nЗакрыть без сохранения?',
    confirmDeleting: 'Подтвердите удаление элемента.',
    error: 'Ошибка',
    loading: 'Загрузка...',
    notFound: 'Не найдено',
    nonBreakingSpace: 'Неразрывный пробел',
    pageContainsUnsavedData: "Страница содержит несохраненные данные.",
    progress: 'Выполнение',
    copiedUrl: "Ссылка скопирована",
    warning: 'Внимание',
    search: 'Поиск',
    copySelected: 'Копировать выбранные',
    cutSelected: 'Вырезать выбранные',
    deleteFolder: "Удалить папку",
    delMark: 'Изменить пометку удаления',
    edit: 'Редактировать',
    editGroup: 'Переименовать группу',
    filter: "Фильтр",
    insert: 'Добавить',
    insertCopy: 'Добавить копированием',
    insertGroup: 'Добавить группу',
    pasteRows: 'Вставить строки',
    reload: "Обновить",
    save: 'Сохранить',
    saveChangesAndClose: 'Сохранить изменения и закрыть',
    copiedToBuffer: "Скопировано в буфер",
    deleteRow: "Удалить строку",
    changeGroup: 'Изменить группу',
    confirmation: 'Требуется подтверждение',
    askDeleteRows: 'Удалить выбранные строки?',
    askDeleteFolders: 'Удалить выбранные папки?',
    askDelMarkRows: 'Изменить пометку удаления?',
    titleRequired: 'Требуется название',
    moveUp: "Переместить вверх",
    moveDown: "Переместить вниз",
    expandText: 'Развернуть текст',
    selectedCount: '{0} выбрано',
    mapZoomHint: 'Используйте <span>&#8984;/Ctrl + скрол</span> для масштабирования',
    archivalDateYearRangePlaceholder: 'г-г',
    archivalDateDecadePlaceholder: 'дк',
    archivalDateYearPlaceholder: 'г',
    archivalDateMonthPlaceholder: 'м',
    archivalDateDayPlaceholder: 'д',
    archivalDateDayRangePlaceholder: 'д-д',
    // Autocomplete, режим mixed: {0} — введённый оператором текст
    acUseAsText: 'Использовать «{0}» как текст',
    // 2026-09-22: всплывающее уведомление о новых сообщениях: {0} — модуль, {1} — число
    newMessageIn: 'Новое сообщение в {0}',
    newMessagesIn: 'Новые сообщения в {0}: {1}',
    acCreate: 'Создать запись «{0}»',
    acOpenCard: 'Открыть карточку',
    acReplace: 'Заменить запись',
    acSelectRecord: 'Выбрать из справочника',
    acConvertToText: 'Преобразовать в текст',
    acClear: 'Очистить',
    acReferenceBadge: 'Запись справочника',
    acReferenceNameMissing: 'Название записи не получено',
    alertDeleteRows: 'Выбранные строки будут удалены окончательно <br/>без возможности восстановления. <br/>Вы уверены?',
    alertDeleteFolders: 'Выбранные папки будут удалены окончательно <br/>без возможности восстановления. <br/>Вы уверены?',
    alertDelMarkRows: 'Изменить пометку удаления для выбранных строк?',
    dataLoading: 'Загрузка данных...',
    groupSelect: 'Выбор группы',
    noItemsSelectedToMove: 'Элементы для перемещения не выбраны',
    selected: 'Выбрано',
    items: 'элементов',
    selectGroupWhichYouWantToMoveItems_Click: 'Выберите в дереве проводника куда нужно переместить отмеченные элементы и нажмите',
    createNewGroup: 'Создание новой группы',
    newGroupName: 'Название новой группы',
    init: "Инициализация",
    savingError: 'Ошибка сохранения',
    unknownEditMode: 'Неизвестный режим редактирования',
    schemaFormModes: 'Режим отображения карточки',
    schemaFormModeDefault: 'Обычный',
    schemaFormModeLanguages: 'Языки',
    schemaFormModeSource: 'Источник',
    schemaFormModeProvenance: 'Provenance',
    schemaFormSelectedField: 'Выбранное поле',
    schemaFormLoading: 'Загружаем сведения о поле…',
    schemaFormEmpty: 'Сохранённых сведений нет',
    schemaFormError: 'Не удалось загрузить данные',
    schemaFormRetry: 'Повторить',
    schemaFormClose: 'Закрыть',
    schemaFormState: 'Состояние',
    schemaFormSource: 'Источник',
    schemaFormSourcePartial: 'Источник частично',
    schemaFormOrigin: 'Происхождение',
    schemaFormApproval: 'Подтверждение',
    schemaFormAttention: 'Внимание',
    schemaFormAttentionAdvisory: 'Желательно заполнить',
    schemaFormAttentionBlocking: 'Требуется заполнить',
    schemaFormItems: 'элементов',
    schemaFormMore: 'ещё',
    schemaFormValue: 'Значение',
    schemaFormAbsent: 'Нет сохранённого значения',
    schemaFormNull: 'Null',
    schemaFormEmptyText: 'Пустая строка',
    schemaFormEmptyCollection: 'Пустая коллекция',
    schemaFormDeleted: 'Удалено',
    schemaFormUnsupported: 'Неподдерживаемое значение',
    datepicker,
    startEndTimecodeNotSpecified: 'Не указан начальный или конечный тайм-код',
    startEndTooCloseToFileBoundaries: 'Начало/конец слишком близко к границам файла',
    timecodeTitleImageIncorrect: 'Не правильно указан тайм-код титульной картинки',
    setIn: 'Установить начало фрагмента',
    setOut: 'Установить конец фрагмента',
    setImgTime: 'Установить титульную картинку',
    size0: 'Переключить на весь экран',
    size1: 'Маленький размер плеера',
    size2: 'Средний размер плеера',
    size3: 'Большой размер плеера',
    prevFrame: 'Перейти к предыдущему кадру',
    prevSecond: 'Перейти к предыдущей секунде',
    playInOut: 'Воспроизвести выделенный фрагмент',
    nextFrame: 'Перейти к следующему кадру',
    nextSecond: 'Перейти к следующей секунде',
    techinfo: 'Технические параметры',
    timeIn: 'Начало фрагмента',
    timeOut: 'Конец фрагмента',
    soundOff: 'Убрать звук',
    upload_processing: "Обработка...",
    upload_supportedFormats: "Поддерживаемые форматы",
    procesNotFound: "Процесс загрузки не найден",
    upload_postprocessError: "Ошибка при постобработке",
    upload_postprocessFaultToStart: "Не удалось запустить постобработку",
    upload_fileAllreadyAdded: "Файл уже был добавлен",
    upload_EmptyFile: "Пустой файл (размер 0 байт)",
    upload_fileNotMatchRequirements: "Файл не соответствует требованиям",
    upload_unrecognizedFileType: "Неопознанный тип файла",
    upload_canceled: "Загрузка отменена",
    upload_cancel: "Отмена загрузки",
    upload_loading: "Загрузка...",
    upload_invalidFileBlob: "Некорректные данные файла",
    upload_httpError: "Ошибка HTTP",
    upload_fileUrlMissing: "Чанковая загрузка завершилась без URL файла",
    systemError: "Системная ошибка",
    uppy: ru_RU
};

export { ru, ruInputFormats };
